"use client";
import { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { MarketingLayout } from "@/components/marketing/MarketingLayout";

// /platform/* is a separate, auth-gated CSR admin app (see src/app/platform/layout.tsx)
// and must not render the public marketing header/footer/chat widget around it. A child
// layout can't remove chrome an ancestor layout already rendered, so the root layout
// defers the decision here instead of wrapping every route in MarketingLayout directly.
export function ConditionalMarketingLayout({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  if (pathname?.startsWith("/platform")) {
    return <>{children}</>;
  }
  return <MarketingLayout>{children}</MarketingLayout>;
}
